if(Wlz.Settings && Wlz.Settings.cityFieldAutoComplete) {
  (function() {
    //Initialize input
    var $input = $(Wlz.Settings.cityFieldAutoComplete.selector);
    $input.attr('autocomplete','off');

    //initilize list
    var $list = $('<ul>').addClass(Wlz.Settings.cityFieldAutoComplete.listClass);
    $list.insertAfter($input);

    var selectedOptionIndex = -1; // -1 = not selected

    function selectItem(index)
    {
      if(index != -1) {
        $input.val(
            $($list.children().get([index])).html()
        );
        $list.hide();
      }
    }

    //Handle return key
    $input.on('keypress', function(e) {
      if(e.keyCode == 13) { //Return
        selectItem(selectedOptionIndex);
      }
      if(e.keyCode == 13 || e.keyCode == 40 || e.keyCode == 38) {
        e.preventDefault();
      }
    });

    //On keyup on input
    var xhr;
    $input.on('keyup', function(e) {
      //Arrow Down
      if(e.keyCode == 40) {
        if(selectedOptionIndex+1<$list.children().length) {
          selectedOptionIndex+=1;
          renderList();
          e.preventDefault();
        }
      } else if(e.keyCode == 38) { //Arrow up
        if(selectedOptionIndex>-1) {
          selectedOptionIndex -= 1;
          renderList();
          e.preventDefault();
        }
      } else if(e.keyCode == 13) { //Return
        // Nothing special
      } else {
        //Abort former ajax request
        if(xhr) {
          xhr.abort()
        }

        //abort if lass than 3 characters
        if ($(this).val().length <= 2) {
          $list.hide();
          return;
        }

        //refresh
        var valBeforeRefresh = $($list.children().get([selectedOptionIndex])).html();
        xhr = $.ajax({
          url: Wlz.Settings.cityFieldAutoComplete.route,
          data: {
            country: 'FR',
            start: $(this).val()
          },
          success: function(result) {
            //Empty list
            $list.html('');

            selectedOptionIndex = -1;
            $(result).each(function(index) {
              //add options
              var $option = $('<li>').html(this.place_name + ' (' + this.post_code + ')');
              $option.on('click', function(){
                console.log('click');
                selectItem(index);
              });
              $list.append($option);

              if($option.html() == valBeforeRefresh) {
                $option.addClass('selected');
                selectedOptionIndex = index;
              }
            });
            $list.show();
          }
        });
        e.preventDefault();
      }
    });
    function renderList(){
      $list.children().removeClass('selected');
      $($list.children().get([selectedOptionIndex])).addClass('selected');
    }

    // focus / blur events
    $input.on('blur', function(e) {
      // If not in timeout, blur is fired before click on option
      // so click is never fired because the element is not displayed
      $list.css('opacity',0);
      setTimeout(
        function(){
          $list.hide();
          $list.css('opacity',1);
        },
        500
      );
    });

    $input.on('focus', function(e) {
      $list.show();
    });
  })();
} else {
  console.log('Wlz.Settings.cityFieldAutoComplete should be filled in')
}
